<template>
    <div class="page-checkout-step-shipping-address-street-dadata-cdek">
        <ui-form
            v-bind:model="fields"
            v-bind:validation="$v"
            v-on:update="updateFormData"
            v-bind:submit-handler="submitHandler"
        />
    </div>
</template>

<script>
import forms from '~/forms';

export default {
    name: 'sideblock-delivery-point-dadata-cdek',
    data: () => ({
        innerFields: {
            street: {
                ...forms.fields.streetDadata,
                label: 'Улица и дом',
                noAsterisk: true,
            },
        },
        resultData: {
            street: null,
            building: null,
            house: null,
            apartment: null,
            postcode: null,
        },
    }),
    mounted() {
        // TODO
        window.setTimeout(() => {
            // eslint-disable-next-line no-unused-expressions
            this.$el.querySelector('input')?.focus();
        }, 1200);
    },
    validations() {
        return {
            fields: {
                street: {
                    value: {
                        ...forms.validations.defaultRequired.value,
                    },
                },
            },
        };
    },
    computed: {
        checkoutData() {
            return this.$store.state.checkout.data;
        },
        fields() {
            const result = { ...this.innerFields };
            if (this.checkoutData.country) {
                result.street.dadataParams = {
                    locations: [{
                        country: this.checkoutData.country.name,
                        city: this.checkoutData.city?.city?.name || this.checkoutData.customCity,
                    }],
                    restrict_value: true,
                };
            }
            result.street.value = this.resultData.street;
            return result;
        },
    },
    methods: {
        updateFormData(newData) {
            const street = newData?.street?.value?.value;
            const data = newData?.street?.value?.data;
            const result = {
                street: street ?? null,
                building: data?.block ?? null,
                house: data?.house ?? null,
                apartment: data?.flat ?? null,
                postcode: data?.postal_code ?? null,
                geo_lat: data?.geo_lat ?? null,
                geo_lon: data?.geo_lon ?? null,
            };
            this.resultData = result;
            this.$emit('dadata-result', this.resultData);
        },
        submitHandler() {
            this.$emit('dadata-result', this.resultData);
        },
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.page-checkout-step-shipping-address-street-dadata-cdek {
}
</style>
